import { isErrorWithMessage } from './isErrorWithMessage';
import { isRESTAPIError } from './RESTAPIError';

/**
 * Extract the API's explanation from either a thrown `RESTAPIError` or the raw error body an
 * `@gonfalon/openapi` operation returns alongside its response, falling back to `fallback`.
 */
export function getAPIErrorMessage(error: unknown, fallback: string): string {
  if (isRESTAPIError(error)) {
    return error.message;
  }

  if (isErrorWithMessage(error)) {
    return error.message;
  }

  return fallback;
}
